
import {registerReducer} from 'js/studios/shared/redux/utils'

function reviews(state={page: 1, reviews: [], filters: {'category': '', 'rating': ''}, numOfPages: 1}, action){
  let newState = Object.assign({}, state)
  switch (action.type){
    case "UPDATE_REVIEWS_SUCCESS":
      return action.responseData
    case "REVIEWS_FILTER_RATING":
      newState.filters = {
        rating: action.rating,
        category: state.filters.category
      }
      newState.page = 1 // always go back to first page on filter change
      return newState
    case "REVIEWS_FILTER_CATEGORY":
      newState.filters = {
        rating: state.filters.rating,
        category: action.category
      }
      newState.page = 1 // always go back to first page on filter change
      return newState
    case "REVIEWS_CHANGE_PAGE":
      newState.page = action.page
      return newState
    default:
      return state
  }
}

registerReducer(reviews, 'reviewPage')
